export default __webpack_public_path__ + "static/media/attribute.066ea544.svg";